import { useEffect } from "react";

export default function JsonLd({ id, data }) {
    useEffect(() => {
        const scriptId = `schema-${id}`;
        let script = document.getElementById(scriptId);

        if (!script) {
            script = document.createElement("script");
            script.id = scriptId;
            script.type = "application/ld+json";
            document.head.appendChild(script);
        }

        script.textContent = JSON.stringify(data);

        return () => script.remove();
    }, [data, id]);

    return null;
}
